export interface TaskItemOutcome {
    id?: string | null;
    actioned: boolean | null;
    notes: string | null;
    version?: number | null;
    createdDate?: string | Date | null;
    createdBy?: string | null;
    lastModifiedDate?: string | Date | null;
    lastModifiedBy?: string | null;
}

export function createTaskItemOutcome(): TaskItemOutcome {
    return {
        actioned: null,
        notes: null,
    };
}
